import React from 'react';
import { Outlet } from 'react-router-dom';
import Breadcrumb from '@/components/common/Breadcrumb';
import SettingSidebarCard from '@/views/admin/settings/component/SettingSidebarCard';

const AdminSettingsLayout = ({ pageTitle }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-12 gap-x-6">
      <div className="md:col-span-12">
        <Breadcrumb pageTitle={pageTitle} />
      </div>
      <div className="md:col-span-4 xl:col-span-3">
        <SettingSidebarCard />
      </div>
      <div className="md:col-span-8 xl:col-span-9">
        <Outlet />
      </div>
    </div>
  );
};

export default AdminSettingsLayout;
